const translations = {
  // Navbar
  nav_home: 'Home',
  nav_shop: 'Shop',
  nav_whiskies: 'Whiskies',
  nav_gins: 'Gins',
  nav_about: 'About',
  nav_our_story: 'Our Story',
  nav_islay: 'Discover Islay',
  nav_speyside: 'Speyside',
  nav_highlands: 'Highlands',
  nav_contact: 'Contact',
  nav_catalog: 'View Catalogue',

  // Hero
  hero_tagline: '',
  hero_title_1: 'The elegance that resides',
  hero_title_2: 'in Scotch Whisky',
  hero_subtitle: 'Whiskies and gins selected from the three great Scottish regions — Islay, Speyside and Highlands. Premium curation for discerning palates.',
  hero_cta_buy: 'Shop Now',
  hero_cta_whiskies: 'View Whiskies',
  hero_islay_sub: 'Peat & Smoke',
  hero_speyside_sub: 'Fruit & Honey',
  hero_highlands_sub: 'Complexity',

  // Featured Products
  featured_label: 'Premium Selection',
  featured_title: 'Featured Products',
  featured_see_all: 'View all',

  // Regions
  regions_label: 'Our Speciality',
  regions_title: 'Three Regions. One Passion.',
  regions_subtitle: 'All our curation is focused on the three Scottish regions that define the most extraordinary in the world of spirits.',
  region_islay_subtitle: 'The Peat Island',
  region_islay_desc: 'On the far southwest of Scotland, Islay produces the most intense and smoky whiskies in the world. The local peat, sea air and Atlantic winds create a unique character — raw, poetic and unmistakable.',
  region_islay_char: 'Peat · Smoke · Sea Salt · Iodine',
  region_islay_link: 'Discover Islay',
  region_islay_accent: 'Smoky & Intense',
  region_speyside_subtitle: 'The Spey Valley',
  region_speyside_desc: 'On the banks of the River Spey, the world\'s most distillery-dense region produces elegant and fruity whiskies. Apple, pear, honey and gentle spices define the style that conquered the world.',
  region_speyside_char: 'Fruit · Honey · Floral · Spice',
  region_speyside_link: 'Discover Speyside',
  region_speyside_accent: 'Fruity & Elegant',
  region_highlands_subtitle: 'The Highlands',
  region_highlands_desc: 'Scotland\'s largest producing region stretches from the northern coasts to the southern mountains. Whiskies of robust, complex and full-bodied character — with notes of sherry, dark fruits and oriental spices.',
  region_highlands_char: 'Sherry · Dark Fruits · Spice · Oak',
  region_highlands_link: 'Explore Highlands',
  region_highlands_accent: 'Full-bodied & Complex',
  region_see_whiskies: 'View Whiskies from',

  // Whiskies Section
  whiskies_label: 'Islay · Speyside · Highlands',
  whiskies_title: 'Scotch Whiskies',
  whiskies_subtitle: 'Single malts selected from the three most iconic regions of Scotland — from the intense peat of Islay to the elegant honey of Speyside and the complexity of the Highlands.',
  whiskies_see_all: 'View all whiskies',
  whiskies_islay_desc: 'Intense peat, sea smoke and Atlantic salt. The rawest and most poetic character of Scotland.',
  whiskies_speyside_desc: 'Ripe fruits, flower honey and gentle spices. The elegance that conquered the world.',
  whiskies_highlands_desc: 'Sherry, dark fruits and rare complexity. Scotland\'s largest and most diverse region.',
  whiskies_discover: 'Discover',

  // Gins Section
  gins_label: 'Spirits from the Scottish Islands',
  gins_title: 'Scottish Gins',
  gins_subtitle: 'Artisan gins produced in the distilleries of Islay, Speyside and Highlands — with local botanicals, spring water and Scotland\'s unique terroir.',
  gins_see_all: 'View all gins',
  gins_banner_label: 'Premium Experience',
  gins_banner_title: 'The Perfect Gin for Every Occasion',
  gins_banner_subtitle: 'Gins crafted with the pure spring water of Islay, Speyside and Highlands — Scottish terroir in every sip.',
  gins_explore: 'Explore Gins',

  // Brand Section
  brand_label: 'Our Mission',
  brand_title_1: 'From the Distilleries of Islay,',
  brand_title_2: 'Speyside and Highlands',
  brand_title_3: 'To Your Glass',
  brand_desc_1: 'Ma Gádeni was born from a passion for the three most iconic regions of Scotland. We personally select every label — from the raw peat of Islay to the elegant honey of Speyside and the complexity of the Highlands — to bring Brazil the finest in the world of Scotch spirits.',
  brand_desc_2: 'Every bottle tells the story of an island, a valley, a mountain. Every sip is a journey to Scotland.',
  brand_authenticity: 'Authenticity',
  brand_rarity: 'Rarity',
  brand_curation: 'Curation',
  brand_link: 'Learn our story',

  // Newsletter
  newsletter_label: 'Stay Connected',
  newsletter_title: 'Subscribe to Our Newsletter',
  newsletter_subtitle: 'Receive news, exclusive releases and stories from the world of rare spirits.',
  newsletter_placeholder: 'Your email',
  newsletter_btn: 'Subscribe',
  newsletter_success: 'Thank you! You have been successfully subscribed.',
  newsletter_error: 'An error occurred. Please try again.',

  // Footer
  footer_tagline: 'From the World\'s Distilleries, to the Sunlit Coast',
  footer_contact: 'Contact Us',
  footer_about: 'About Us',
  footer_whiskies: 'Our Whiskies',
  footer_rights: '© 2025 Ma Gádeni. All rights reserved',

  // Our Story
  story_hero_tagline: 'From the World\'s Distilleries to the Sunlit Coast: A Journey of Rare Spirits.',
  story_hero_title: 'Our Story',
  story_breadcrumb_home: 'Home',
  story_hero_desc: 'Discover Ma Gádeni, a sanctuary of rare whiskies in Northeast Brazil. Born from a unique partnership, we curate rare single malts from Scotland and other extraordinary spirits for the discerning collector.',
  story_essence_title: 'The Essence of Ma Gádeni',
  story_essence_p1: 'Ma Gádeni, \'the gardens\' in Chichewa, is more than a name; it is our philosophy. It represents a sanctuary where things of beauty and rarity are cultivated to flourish. Our sanctuary is in the heart of Natal, Brazil — a serene smallholding where the vibrant energy of the Northeast meets the timeless soul of the world\'s finest whiskies.',
  story_essence_p2: 'While our heart and foundation lie in peated Scottish single malts, our passion extends to the entire world of exceptional distillation. We are guardians of rarity. Our mission is to seek out the most exclusive, limited edition and discontinued whiskies — primarily from the remote distilleries of Scotland, but also including other notable discoveries that tell a unique story. We import in minimal quantities, ensuring that every bottle we offer is not merely a drink, but a piece of history, a narrative in a glass.',
  story_promise_label: 'The Ma Gádeni Promise: Provenance and Legacy',
  story_promise_quote: 'We operate on a simple and uncompromising principle: quality above quantity.',
  story_trio_title: 'Our Unlikely Trio',
  story_trio_subtitle: 'The Roots of a Dream',
  story_trio_desc: 'Ma Gádeni was born from the confluence of three worlds, a partnership as unique as the whiskies we cherish.',
  story_leda_role: 'The Soul of Seridó',
  story_leda_bio: 'With roots in the historic city of Caicó and having made Natal her home for much of her adult life, Leda embodies the rich cultural tapestry of Rio Grande do Norte. She is the heart of our venture, possessing an innate understanding of the regional palate for celebration and sophistication. It was her vision to create an unparalleled luxury experience in the Northeast, bringing a taste of the world\'s finest to our corner of Brazil.',
  story_thomas_role: 'The Guardian of Tradition',
  story_thomas_bio: 'With a lifelong passion for the water of life — uisge-beatha — Thomas is our connoisseur and storyteller. His deep knowledge of Scottish distilleries and his respect for the distiller\'s art allow him to seek out those hidden gems that escape the mainstream. He is the bridge, connecting the misty glens of Scotland to the sun-drenched land of our smallholding.',
  story_jade_role: 'The New Generation',
  story_jade_bio: 'Thomas\'s daughter, Jade, represents the future. With a modern eye and a deep respect for the legacy we are building, she weaves the rich narratives of our whiskies with contemporary Brazilian lifestyle. She ensures that Ma Gádeni\'s story is not just preserved, but evolved.',
  story_closing: 'Together, we are a family. We believe the best pleasures in life are those shared, and the best stories are told over a truly exceptional drink.',
  story_explore_label: 'Ready to Explore Our Curated Collection?',
  story_explore_desc: 'Discover the current rare single malts and other exceptional whiskies that have found their temporary home in our smallholding.',
  story_contact_us: 'Contact Us',
  story_pillar1_label: 'An Experience, Not Just a Purchase',
  story_pillar1_desc: 'When you acquire a whisky from Ma Gádeni, you are acquiring a piece of a journey — from a renowned Scottish distillery or a hidden workshop elsewhere in the world, to our tranquil Brazilian gardens and, finally, to your glass.',
  story_pillar2_label: 'A Curated Sanctuary:',
  story_pillar2_desc: 'We do not work with mass-market spirits. Our core collection is built on rare Scottish single malts, hand-selected for their unique character, age and story.',
  story_pillar3_label: 'A Personal Journey:',
  story_pillar3_desc: 'Each import is a personal mission. We build relationships with distillers and brokers, ensuring authenticity and exclusivity for our clients.',
  story_form_title: 'Contact Us',
  story_form_label: 'Get in Touch',
  story_form_desc: 'Would you like to know more about our exclusive labels? Fill in the form and we will get back to you shortly.',
  story_form_location: 'Location',
  story_form_location_val: 'Natal — RN',
  story_form_provenance: 'Provenance',
  story_form_provenance_val: 'Selected imports',
  story_form_hours: 'Hours',
  story_form_hours_val: 'Monday to Friday, 9am–6pm',
  story_form_quote: '"Every bottle tells a story. Let us tell yours."',
  story_form_success: 'Message sent!',
  story_form_success_sub: 'We will get back to you shortly.',
  story_form_name: 'Full Name',
  story_form_phone: 'Phone',
  story_form_email: 'Email',
  story_form_interest: 'You are interested in:',
  story_form_message: 'How Can We Help You?',
  story_form_send: 'Send Message',
  story_form_sending: 'Sending...',

  // Contact
  contact_hero_tagline: 'Ma Gádeni · Natal, RN',
  contact_hero_title: 'Contact Us',
  contact_breadcrumb_home: 'Home',
  contact_location_label: 'Location',
  contact_location_val: 'Natal — RN, Brazil',
  contact_location_sub: 'Private smallholding',
  contact_hours_label: 'Hours',
  contact_hours_val: 'Mon – Fri, 9am to 6pm',
  contact_hours_sub: 'Brasília Time',
  contact_provenance_label: 'Provenance',
  contact_provenance_val: 'Selected imports',
  contact_provenance_sub: 'Scotland · Ireland · World',
  contact_map_label: 'Where We Are',
  contact_map_title: 'Natal, Rio Grande do Norte',
  contact_social_label: 'Follow Us',
  contact_form_label: 'Send a Message',
  contact_form_title: 'Get in Touch',
  contact_form_success: 'Message sent!',
  contact_form_success_sub: 'Thank you for reaching out. We will get back to you shortly, within business hours.',
  contact_form_new: 'New Message',
  contact_form_name: 'Full Name',
  contact_form_phone: 'Phone',
  contact_form_email: 'Email',
  contact_form_interest: 'Interested in:',
  contact_form_message: 'How Can We Help You?',
  contact_form_send: 'Send Message',
  contact_form_sending: 'Sending...',
  contact_form_error: 'An error occurred. Please try again.',
  contact_cta_label: 'Explore Our Collection',
  contact_cta_title: 'From the World\'s Distilleries to Your Glass',
  contact_cta_desc: 'Discover rare single malts from Islay, Speyside and Highlands — passionately selected and imported in minimal quantities to Northeast Brazil.',
  contact_cta_btn: 'View Catalogue',
  contact_cta_story: 'Our Story',

  // Shop / Whiskies / Gins pages
  shop_title: 'Our Shop',
  shop_featured: 'Featured',
  shop_price_asc: 'Lowest Price',
  shop_price_desc: 'Highest Price',
  shop_name_az: 'A–Z',
  shop_category: 'Category',
  shop_all: 'All',
  shop_whiskies: 'Whiskies',
  shop_gins: 'Gins',
  shop_empty: 'No products found.',
  shop_clear: 'Clear filters',
  shop_buy: 'Buy',
  shop_hero_label: 'Ma Gádeni',

  whiskies_page_label: 'Premium Category',
  whiskies_page_title: 'Whiskies',
  whiskies_page_subtitle: 'From the turbulent coasts of Islay to the gentle hills of Speyside — the finest single malts and blends in the world.',
  whiskies_page_empty: 'No whiskies found with these filters.',
  whiskies_page_clear: 'Clear filters',
  whiskies_region_all: 'All',
  whiskies_style_all: 'All',
  whiskies_style_label: 'Style',

  gins_page_label: 'Premium Category',
  gins_page_title: 'Gins',
  gins_page_subtitle: 'From classic London Dry to contemporary floral and spiced — character gins for unique moments.',
  gins_page_empty: 'No gins found with these filters.',
  gins_page_clear: 'Clear filters',
  gins_origin_label: 'Origin',
  gins_origin_all: 'All',
  gins_style_all: 'All',

  // Islay page
  islay_about: 'About',
  islay_title: 'Discover Islay',
  islay_island: 'The Island',
  islay_h2: 'The Untamed Soul of Scotch Whisky',
  islay_p1: 'Islay is a remote island off the west coast of Scotland, swept by Atlantic winds and covered by vast peat bogs. With only 3,000 inhabitants, it is home to some of the most legendary distilleries in the world — and produces whiskies that are unmistakable in any tasting.',
  islay_p2: 'The unique character of Islay whiskies comes from peat — a layer of decomposed organic matter that covers much of the island. When burned to dry malted barley, it releases a dense, aromatic smoke that permeates the grain with deep flavours of smokiness, iodine, sea salt and tar.',
  islay_video_title: 'See Islay in All Its Splendour',
  islay_distilleries_label: 'Distilleries',
  islay_distilleries_title: 'The Legends of Islay',
  islay_peat_label: 'The Secret',
  islay_peat_title: 'The Magic in the Smoke: Where Flavour is Forged',
  islay_peat_p1: 'The genius of Islay whisky lies in a single transformative step. To halt the germination of the barley, distillers dry it over smouldering peat fire. The thick, aromatic smoke does not merely dry the grain — it saturates it, imbuing it with the deep and complex character of the island itself.',
  islay_peat_p2: 'The level of smokiness is measured in PPM (parts per million of phenol). While a standard whisky has fewer than 5 PPM, Islay whiskies can reach 50, 100 or even over 200 PPM in the case of Octomore.',

  // Speyside page
  speyside_about: 'About',
  speyside_title: 'Discover Speyside',
  speyside_region: 'The Region',
  speyside_h2: 'The Elegance That Resides in Scotch Whisky',
  speyside_p1: 'To understand Speyside, set aside notions of coastal storms and smoky peat. Travel instead to the gentle, rolling valleys of Scotland\'s heartland. Here, sheltered by ancient hills and fed by pure, soft-water rivers, lies a region where whisky-making is an art of refinement, not resilience.',
  speyside_p2: 'Nestled in these fertile valleys, Speyside\'s distilleries are blessed with a milder climate. This environment is the key to their character. Without the need for pungent peat smoke, distillers here focus on the pure, clean expression of the barley itself.',
  speyside_char_label: 'Sensory Profile',
  speyside_char_title: 'The Character of Speyside',
  speyside_char_desc: 'Speyside whiskies are recognised worldwide for their elegance, complexity and accessibility. Discover the flavours that define this extraordinary region.',
  speyside_dist_label: 'Distilleries',
  speyside_dist_title: 'The Great Names of Speyside',
  speyside_cta_title: 'Speak with a specialist now',
  speyside_cta_desc: 'Our team is ready to help you find the perfect Speyside whisky for your palate and occasion.',
  speyside_cta_btn: 'Contact Us',

  // Product card badges & category
  badge_best_seller: 'Best Seller',
  badge_new: 'New',
  badge_premium: 'Premium',
  badge_cask_strength: 'Cask Strength',
  badge_classic: 'Classic',
  badge_exclusive: 'Exclusive',
  badge_limited: 'Limited Edition',
  badge_navy: 'Navy Strength',
  badge_imported: 'Imported',
  card_cat_whisky: 'Whisky',
  card_cat_gin: 'Gin',

  // Product page
  product_not_found: 'Product not found',
  product_back_shop: 'Back to shop',
  product_cat_whisky: 'Premium Whisky',
  product_cat_gin: 'Artisan Gin',
  product_spec_age: 'Age',
  product_spec_abv: 'ABV',
  product_spec_origin: 'Origin',
  product_spec_style: 'Style',
  product_price: 'Price',
  product_tax: 'Taxes included',
  product_add_cart: 'Add to Cart',
  product_added: 'Added!',
  product_buy_now: 'Buy Now',
  product_trust_auth: 'Authentic Product',
  product_trust_ship: 'Safe Delivery',
  product_trust_quality: 'Quality Guaranteed',
  product_description: 'Description',
  product_read_more: 'Read more',
  product_read_less: 'Read less',
  product_tasting: 'Tasting Notes',
  product_nose: 'Nose',
  product_palate: 'Palate',
  product_finish: 'Finish',
  product_awards: 'Awards & Recognition',
  product_related_label: 'You May Also Like',
  product_related_title: 'Related Products',
  product_see_all: 'View all',

  // Highlands page
  highlands_about: 'About',
  highlands_title: 'Highlands',
  highlands_largest: 'The Largest Region',
  highlands_h2: 'Where Purity is Distilled into Legend',
  highlands_p1: 'The Highlands form Scotland\'s largest and most diverse whisky-producing region, encompassing both the mainland and several famous islands. As such, they produce some of the most distinctive and legendary whiskies in the world.',
  highlands_p2: 'Each sub-region carries its own identity, shaped by the harsh climate, isolated geography and the purity of its waters. The whiskies do not follow a single style — they range from the lightest and fruitiest to the most intense, saline and lightly peated.',
  highlands_sub_label: 'Sub-regions',
  highlands_sub_title: 'The Diversity of the Highlands',
  highlands_dist_label: 'Distilleries',
  highlands_dist_title: 'Icons of the Highlands',
  highlands_cta_title: 'Explore Highlands Whiskies',
  highlands_cta_desc: 'Discover our curated selection of rare Highland expressions, chosen with passion and expertise by the Ma Gádeni team.',
  highlands_cta_btn: 'View Catalogue',
};

export default translations;
